/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
  bearer: string;
};

type HookTuple = [
  response: vp.EftWithdrawTransactionResponse,
  fetchData: (transactionID: string) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchEFTWithdrawTransaction: ApiHook = ({ api, bearer }: HookProps) => {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<string>();
  const [response, setResponse] = useState<vp.EftWithdrawTransactionResponse>({
    Success: true,
    ErrorMessage: '',
    FailureReason: '',
    TransactionID: '',
    TransactionStatus: vp.TransactionStatus.SUCCESSFUL,
    TransactionDateTime: '',
    HoldReleaseDateTime: '',
    Amount: '',
    Currency: 'CAD',
    HoldAmount: '',
    ScheduledTransactionID: '',
    FirstName: '',
    LastName: '',
    CompanyName: '',
    RecipientName: '',
    DOB: '',
    PhoneNumber: '',
    Email: '',
    Address1: '',
    Address2: '',
    City: '',
    Province: '',
    Country: '',
    PostalCode: '',
    FinancialInstitutionNumber: '',
    BranchTransitNumber: '',
    AccountNumber: '',
    ClientReferenceNumber: '',
    ParentTransaction: [],
    LastModified: '',
    ABARoutingNumber: '',
    IBAN: '',
    Iq11: '',
    KYCPerformed: '',
    KYCReferenceNumber: '',
    SortCode: '',
    ParentTransactionID: '',
    GLCode: '',
    WireReferenceNumber: '',
    TransactionTypeCode: '',
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: string) => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');

      const res = await api.fetchEFTWithdrawTransaction({ TransactionID: requestParams }, bearer, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: string) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: true,
        ErrorMessage: '',
        FailureReason: '',
        TransactionID: '',
        TransactionStatus: vp.TransactionStatus.SUCCESSFUL,
        TransactionDateTime: '',
        HoldReleaseDateTime: '',
        Amount: '',
        Currency: 'CAD',
        HoldAmount: '',
        ScheduledTransactionID: '',
        FirstName: '',
        LastName: '',
        CompanyName: '',
        RecipientName: '',
        DOB: '',
        PhoneNumber: '',
        Email: '',
        Address1: '',
        Address2: '',
        City: '',
        Province: '',
        Country: '',
        PostalCode: '',
        FinancialInstitutionNumber: '',
        BranchTransitNumber: '',
        AccountNumber: '',
        ClientReferenceNumber: '',
        ParentTransaction: [],
        LastModified: '',
        ABARoutingNumber: '',
        IBAN: '',
        Iq11: '',
        KYCPerformed: '',
        KYCReferenceNumber: '',
        SortCode: '',
        ParentTransactionID: '',
        GLCode: '',
        WireReferenceNumber: '',
        TransactionTypeCode: '',
      });
      setSendRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchEFTWithdrawTransaction);
